export default "__VITE_ASSET__BhmFrnFK__"